var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	2498: () => (loadSingletonVersion("default", "react", true, [4,19,3,0], () => (() => (__webpack_require__(2483))))),
	9643: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [4,2,12,0], () => (Promise.all([__webpack_require__.e(2493), __webpack_require__.e(9649)]).then(() => (() => (__webpack_require__(9649))))))),
	9460: () => (loadSingletonVersion("default", "react-redux", false, [4,9,3,0], () => (Promise.all([__webpack_require__.e(9272), __webpack_require__.e(2498)]).then(() => (() => (__webpack_require__(9272))))))),
	883: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,11,18], () => (Promise.all([__webpack_require__.e(5181), __webpack_require__.e(2498), __webpack_require__.e(9643), __webpack_require__.e(9460), __webpack_require__.e(7532), __webpack_require__.e(18), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(5181))))))),
	7532: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-constants", false, [4,0,1,95], () => (__webpack_require__.e(9192).then(() => (() => (__webpack_require__(9192))))))),
	18: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-web-trading", false, [4,2,0,63], () => (__webpack_require__.e(7235).then(() => (() => (__webpack_require__(7235))))))),
	2645: () => (loadSingletonVersion("default", "dayjs", false, [4,1,11,23], () => (__webpack_require__.e(4686).then(() => (() => (__webpack_require__(4686))))))),
	3945: () => (loadSingletonVersion("default", "js-cookie", false, [1,3,0,8], () => (__webpack_require__.e(38).then(() => (() => (__webpack_require__(38))))))),
	8077: () => (loadSingletonVersion("default", "react-dom", false, [4,19,3,0], () => (__webpack_require__.e(7617).then(() => (() => (__webpack_require__(9998))))))),
	3526: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-instruments", false, [4,1,2,51], () => (Promise.all([__webpack_require__.e(2006), __webpack_require__.e(7532), __webpack_require__.e(18), __webpack_require__.e(2645)]).then(() => (() => (__webpack_require__(2006))))))),
	8184: () => (loadSingletonVersion("default", "styled-components", false, [4,6,5,3], () => (Promise.all([__webpack_require__.e(8586), __webpack_require__.e(4406)]).then(() => (() => (__webpack_require__(8586))))))),
	5955: () => (loadSingletonVersion("default", "react-router", false, [4,8,4,0], () => (__webpack_require__.e(6132).then(() => (() => (__webpack_require__(6132))))))),
	3074: () => (loadSingletonVersion("default", "i18next", false, [4,26,4,2], () => (__webpack_require__.e(5032).then(() => (() => (__webpack_require__(5032))))))),
	7366: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-marketdata", false, [4,1,1,49], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(5868), __webpack_require__.e(7532), __webpack_require__.e(18)]).then(() => (() => (__webpack_require__(5868))))))),
	30: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-client", false, [4,1,9,72], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(1216), __webpack_require__.e(2498), __webpack_require__.e(7532), __webpack_require__.e(18), __webpack_require__.e(2645), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(1216))))))),
	4995: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-frontend-hooks", false, [4,1,0,34], () => (__webpack_require__.e(2177).then(() => (() => (__webpack_require__(4558))))))),
	517: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-accounts", false, [4,2,1,43], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(3052)]).then(() => (() => (__webpack_require__(3052))))))),
	1270: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-messages", false, [4,1,0,19], () => (__webpack_require__.e(3967).then(() => (() => (__webpack_require__(6348))))))),
	2052: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-design-system", false, [4,0,88,41], () => (Promise.all([__webpack_require__.e(1161), __webpack_require__.e(1186), __webpack_require__.e(4406), __webpack_require__.e(1041), __webpack_require__.e(1861)]).then(() => (() => (__webpack_require__(1186))))))),
	2333: () => (loadSingletonVersion("default", "@grafana/faro-react", false, [1,2,12,0], () => (__webpack_require__.e(4375).then(() => (() => (__webpack_require__(4375))))))),
	2577: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-exchange", false, [4,1,7,11], () => (Promise.all([__webpack_require__.e(3837), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(3837))))))),
	2932: () => (loadSingletonVersion("default", "usehooks-ts", false, [4,3,1,1], () => (__webpack_require__.e(125).then(() => (() => (__webpack_require__(125))))))),
	3067: () => (loadSingletonVersion("default", "i18next-xhr-backend", false, [4,3,2,2], () => (__webpack_require__.e(4720).then(() => (() => (__webpack_require__(4720))))))),
	3289: () => (loadSingletonVersion("default", "react-device-detect", false, [4,2,2,3], () => (__webpack_require__.e(8850).then(() => (() => (__webpack_require__(8850))))))),
	4470: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-watchlists", false, [4,1,3,50], () => (__webpack_require__.e(2988).then(() => (() => (__webpack_require__(2988))))))),
	4973: () => (loadSingletonVersion("default", "react-i18next", false, [4,17,0,14], () => (__webpack_require__.e(3291).then(() => (() => (__webpack_require__(3291))))))),
	5977: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-subscriptions", false, [4,0,1,3], () => (__webpack_require__.e(9838).then(() => (() => (__webpack_require__(7457))))))),
	6557: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-analytics", false, [4,2,1,36], () => (__webpack_require__.e(9422).then(() => (() => (__webpack_require__(9422))))))),
	7001: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-ipo", false, [4,0,0,6], () => (__webpack_require__.e(8665).then(() => (() => (__webpack_require__(1046))))))),
	7200: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-wealth-portfolios", false, [4,1,0,6], () => (Promise.all([__webpack_require__.e(4639), __webpack_require__.e(6916)]).then(() => (() => (__webpack_require__(4535))))))),
	7676: () => (loadSingletonVersion("default", "@cmctechnology/semantic-conventions", false, [4,1,2,1], () => (__webpack_require__.e(6669).then(() => (() => (__webpack_require__(6669))))))),
	7998: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-account-management", false, [4,0,2,23], () => (Promise.all([__webpack_require__.e(7831), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(7831))))))),
	8681: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-charts", false, [4,1,7,0], () => (__webpack_require__.e(8273).then(() => (() => (__webpack_require__(8273))))))),
	8777: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-orders", false, [4,1,0,14], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(1702)]).then(() => (() => (__webpack_require__(9321))))))),
	8865: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-module", false, [4,1,2,18], () => (__webpack_require__.e(5499).then(() => (() => (__webpack_require__(7880))))))),
	4406: () => (loadSingletonVersion("default", "stylis", false, [4,4,4,0], () => (__webpack_require__.e(9049).then(() => (() => (__webpack_require__(9049))))))),
	6748: () => (loadSingletonVersion("default", "lodash.merge", false, [4,4,6,2], () => (__webpack_require__.e(4147).then(() => (() => (__webpack_require__(4147))))))),
	7282: () => (loadSingletonVersion("default", "react-select", false, [4,5,10,2], () => (__webpack_require__.e(8268).then(() => (() => (__webpack_require__(8268))))))),
	3707: () => (loadSingletonVersion("default", "@forgerock/javascript-sdk", false, [4,4,9,1], () => (Promise.all([__webpack_require__.e(2493), __webpack_require__.e(6011)]).then(() => (() => (__webpack_require__(6011))))))),
	4639: () => (loadSingletonVersion("default", "react", true, [4,19,3,0], () => (() => (__webpack_require__(3182)))))
};
// no consumes in initial chunks
const chunkMapping = {
	"18": [
		18
	],
	"30": [
		30
	],
	"883": [
		883
	],
	"1017": [
		517,
		1270,
		2052,
		2333,
		2577,
		2932,
		3067,
		3289,
		4470,
		4973,
		5977,
		6557,
		7001,
		7200,
		7676,
		7998,
		8681,
		8777,
		8865
	],
	"1041": [
		6748,
		7282
	],
	"2498": [
		2498
	],
	"2645": [
		2645
	],
	"3074": [
		3074
	],
	"3526": [
		3526
	],
	"3707": [
		3707
	],
	"3945": [
		3945
	],
	"4406": [
		4406
	],
	"4639": [
		4639
	],
	"4995": [
		4995
	],
	"5955": [
		5955
	],
	"7366": [
		7366
	],
	"7532": [
		7532
	],
	"8077": [
		8077
	],
	"8184": [
		8184
	],
	"9460": [
		9460
	],
	"9643": [
		9643
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}